import { useState } from 'react'

interface DeleteConfirmModalProps {
  tableName: string
  primaryKey: string
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
}

export function DeleteConfirmModal({
  tableName,
  primaryKey,
  onConfirm,
  onCancel,
  isLoading = false,
}: DeleteConfirmModalProps) {
  const [confirmText, setConfirmText] = useState('')

  const isConfirmValid = confirmText === 'DELETE' || confirmText === primaryKey

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ margin: 0, color: 'var(--color-danger)' }}>Delete Row</h3>
        </div>

        <div>
          <p style={{ marginBottom: 'var(--spacing-md)' }}>
            You are about to permanently delete a row from <strong>{tableName}</strong>.
          </p>

          <div style={{
            backgroundColor: 'var(--color-bg-tertiary)',
            padding: 'var(--spacing-md)',
            borderRadius: 'var(--radius-md)',
            marginBottom: 'var(--spacing-md)',
          }}>
            <div style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--spacing-xs)' }}>
              Primary Key
            </div>
            <div style={{ fontFamily: 'var(--font-family-mono)' }}>
              {primaryKey}
            </div>
          </div>

          <p style={{
            marginBottom: 'var(--spacing-sm)',
            color: 'var(--color-text-secondary)',
          }}>
            To confirm, type <strong>DELETE</strong> or the primary key value below:
          </p>

          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type DELETE to confirm"
            autoFocus
            style={{
              borderColor: confirmText && !isConfirmValid
                ? 'var(--color-danger)'
                : undefined,
            }}
          />
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={!isConfirmValid || isLoading}
          >
            {isLoading ? 'Deleting...' : 'Delete Row'}
          </button>
        </div>
      </div>
    </div>
  )
}
